export default [
  {
    path: '/:projectId/encoder-dashboard',
    component: () => import('@/views/encoder/dashboard/EncoderDashboard.vue'),
    name: 'encoder-dashboard',
    meta: {
      projectRequired: true,
      pageTitle: 'Dashboard',
      rule: 'admin',
      navActiveLink: 'encoder-dashboard',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Dashboard', active: true },
      ],
    },
  },
  {
    path: '/:projectId/jobs',
    component: () => import('@/views/encoder/jobs/Jobs.vue'),
    name: 'jobs',
    meta: {
      projectRequired: true,
      pageTitle: 'Jobs',
      rule: 'admin',
      navActiveLink: 'jobs',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Jobs', active: true },
      ],
      redirectTo: 'jobs',
    },
  },
  {
    path: '/:projectId/live-encoder',
    component: () => import('@/views/encoder/live-encoder/LiveEncoder.vue'),
    name: 'live-encoder',
    meta: {
      projectRequired: true,
      pageTitle: 'Live Jobs',
      rule: 'admin',
      navActiveLink: 'live-encoder',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Live Jobs', active: true },
      ],
      redirectTo: 'live-encoder',
    },
  },
  {
    path: '/:projectId/live-encoder/create',
    component: () => import('@/views/encoder/live-encoder/Create.vue'),
    name: 'create-live-encoder',
    meta: {
      projectRequired: true,
      pageTitle: 'Create Live Job',
      rule: 'admin',
      navActiveLink: 'live-encoder',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Live Jobs', to: { name: 'live-encoder' } },
        { text: 'Create Live Job', active: true },
      ],
      redirectTo: 'live-encoder',
    },
  },
  {
    path: '/:projectId/live-encoder/:name/settings',
    component: () => import('@/views/encoder/live-encoder/settings/Settings.vue'),
    name: 'live-encoder-settings',
    meta: {
      projectRequired: true,
      pageTitle: 'Live Job Settings',
      rule: 'admin',
      navActiveLink: 'live-encoder',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Live Jobs', to: { name: 'live-encoder' } },
        { text: 'Live Job Settings', active: true },
      ],
      redirectTo: 'live-encoder',
    },
  },
  {
    path: '/:projectId/jobs/create',
    component: () => import('@/views/encoder/jobs/CreateJob.vue'),
    name: 'jobs-create',
    meta: {
      projectRequired: true,
      rule: 'admin',
      pageTitle: 'Create Job',
      navActiveLink: 'jobs',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Jobs', to: { name: 'jobs' } },
        { text: 'Create Job', active: true },
      ],
      redirectTo: 'jobs',
    },
  },
  {
    path: '/:projectId/jobs/:name',
    component: () => import('@/views/encoder/jobs/JobSummary.vue'),
    name: 'jobs-summary',
    meta: {
      projectRequired: true,
      rule: 'admin',
      pageTitle: 'Job Summary',
      navActiveLink: 'jobs',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Jobs', to: { name: 'jobs' } },
        { text: 'Job Summary', active: true },
      ],
      redirectTo: 'jobs',
    },
  },
  {
    path: '/:projectId/jobs/:name/clone',
    component: () => import('@/views/encoder/jobs/CloneJob.vue'),
    name: 'clone-job',
    meta: {
      projectRequired: true,
      rule: 'admin',
      pageTitle: 'Job Summary',
      navActiveLink: 'jobs',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Jobs', to: { name: 'jobs' } },
        { text: 'Clone Job', active: true },
      ],
      redirectTo: 'jobs',
    },
  },
  {
    path: '/:projectId/job-templates',
    component: () => import('@/views/encoder/job-templates/JobTemplates.vue'),
    name: 'job-templates',
    meta: {
      projectRequired: true,
      pageTitle: 'Job Templates',
      rule: 'admin',
      navActiveLink: 'job-templates',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Job Templates', active: true },
      ],
    },
  },
  {
    path: '/:projectId/job-templates/new',
    component: () => import('@/views/encoder/job-templates/CreateJobTemplate.vue'),
    name: 'job-templates-new',
    meta: {
      projectRequired: true,
      rule: 'admin',
      navActiveLink: 'job-templates',
      pageTitle: 'Create Job Template',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Job Templates', to: { name: 'job-templates' } },
        { text: 'Create Job Template', active: true },
      ],
      redirectTo: 'job-templates',
    },
  },
  {
    path: '/:projectId/job-templates/:id',
    component: () => import('@/views/encoder/job-templates/ViewJobTemplate.vue'),
    name: 'job-templates-view',
    meta: {
      projectRequired: true,
      rule: 'admin',
      pageTitle: 'View Job Template',
      navActiveLink: 'job-templates',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Job Templates', to: { name: 'job-templates' } },
        { text: 'View Job Template', active: true },
      ],
    },
  },
  {
    path: '/:projectId/job-templates/:id/edit',
    component: () => import('@/views/encoder/job-templates/EditJobTemplate.vue'),
    name: 'job-templates-edit',
    meta: {
      projectRequired: true,
      rule: 'admin',
      pageTitle: 'Edit Job Template',
      navActiveLink: 'job-templates',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Job Templates', to: { name: 'job-templates' } },
        { text: 'Edit Job Template', active: true },
      ],
      redirectTo: 'job-templates',
    },
  },
  {
    path: '/:projectId/output-presets',
    component: () => import('@/views/encoder/output-presets/OutputPresets.vue'),
    name: 'output-presets',
    meta: {
      projectRequired: true,
      rule: 'admin',
      navActiveLink: 'output-presets',
      pageTitle: 'Output Presets',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Output Presets', active: true },
      ],
    },
  },
  {
    path: '/:projectId/output-presets/new',
    component: () => import('@/views/encoder/output-presets/CreateOutputPreset.vue'),
    name: 'output-presets-new',
    meta: {
      projectRequired: true,
      rule: 'admin',
      navActiveLink: 'output-presets',
      pageTitle: 'Create Output Preset',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Output Presets', to: { name: 'output-presets' } },
        { text: 'Create Output Preset', active: true },
      ],
      redirectTo: 'output-presets',
    },
  },
  {
    path: '/:projectId/output-presets/:id',
    component: () => import('@/views/encoder/output-presets/ViewOutputPreset.vue'),
    name: 'output-presets-view',
    meta: {
      projectRequired: true,
      rule: 'admin',
      navActiveLink: 'output-presets',
      pageTitle: 'View Output Preset',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Output Presets', to: { name: 'output-presets' } },
        { text: 'View Output Preset', active: true },
      ],
    },
  },
  {
    path: '/:projectId/output-presets/:id/edit',
    component: () => import('@/views/encoder/output-presets/EditOutputPreset.vue'),
    name: 'output-presets-edit',
    meta: {
      projectRequired: true,
      rule: 'admin',
      navActiveLink: 'output-presets',
      pageTitle: 'Edit Output Preset',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Output Presets', to: { name: 'output-presets' } },
        { text: 'Edit Output Preset', active: true },
      ],
      redirectTo: 'output-presets',
    },
  },
  {
    path: '/:projectId/drm',
    component: () => import('@/views/encoder/drm/Drm.vue'),
    name: 'drm',
    meta: {
      projectRequired: true,
      pageTitle: 'Digital Rights Management (DRM)',
      rule: 'admin',
      navActiveLink: 'drm',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Digital Rights Management (DRM)', active: true },
      ],
      redirectTo: 'drm',
    },
  },
  {
    path: '/:projectId/drm/edit',
    component: () => import('@/views/encoder/drm/DrmEdit.vue'),
    name: 'drm-edit',
    meta: {
      projectRequired: true,
      pageTitle: 'Digital Rights Management (DRM)',
      rule: 'admin',
      navActiveLink: 'drm',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Digital Rights Management (DRM)', to: { name: 'drm' } },
        { text: 'Edit', active: true },
      ],
      redirectTo: 'drm-edit',
    },
  },
  {
    path: '/:projectId/live-hubs',
    component: () => import('@/views/encoder/live-hubs/LiveHubs.vue'),
    name: 'live-hubs',
    meta: {
      projectRequired: true,
      pageTitle: 'Live Hubs',
      rule: 'admin',
      navActiveLink: 'encoder',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Live Hubs', active: true },
      ],
      redirectTo: 'live-hubs',
    },
  },
  {
    path: '/:projectId/live-hubs/:liveHubName/settings',
    component: () => import('@/views/encoder/live-hubs/Settings.vue'),
    name: 'live-hub-settings',
    meta: {
      projectRequired: true,
      pageTitle: 'Live Hub',
      rule: 'admin',
      navActiveLink: 'live-hubs',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Live Hubs', to: { name: 'live-hubs' } },
        { text: 'Live Hub Settings', active: true },
      ],
      redirectTo: 'live-hubs',
    },
  },
  {
    path: '/:projectId/live-hubs/create',
    component: () => import('@/views/encoder/live-hubs/helpers/Add.vue'),
    name: 'create-live-hub',
    meta: {
      projectRequired: true,
      pageTitle: 'Create Live Hub',
      rule: 'admin',
      navActiveLink: 'live-hubs',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Live Hubs', to: { name: 'live-hubs' } },
        { text: 'Create', active: true },
      ],
      redirectTo: 'live-hubs',
    },
  },
  {
    path: '/:projectId/live-hubs/:liveHubName/edit',
    component: () => import('@/views/encoder/live-hubs/helpers/Edit.vue'),
    name: 'edit-live-hub',
    meta: {
      projectRequired: true,
      pageTitle: 'Edit Live Hub',
      rule: 'admin',
      navActiveLink: 'live-hubs',
      breadcrumb: [
        { text: 'Encoder', disabled: true },
        { text: 'Live Hubs', to: { name: 'live-hubs' } },
        { text: 'Edit', active: true },
      ],
      redirectTo: 'live-hubs',
    },
  },
]
